import { getCommonCompetence } from "../../utils"

import style from "./style.module.scss"

import { Competence } from "utils/interfaces"
import { Img } from "ui-kit/components-branded"
import { SurveyResultsStorage } from "modules/NewClientSurvey/common/utils/SurveyResultsStorage"

interface CompetenceTitleProps {
    competence: Competence[]
}

export const CompetenceTitle = ({ competence }: CompetenceTitleProps) => {
    const reportedProblemsIds = SurveyResultsStorage.reportedProblemsId
    const reportedProblemsNumbersLength = reportedProblemsIds.length
    const noDuplicateCompetence = competence.filter(
        (value, index, self) => index === self.findIndex((t) => t.id === value.id)
    )
    const commonCompetence = getCommonCompetence(noDuplicateCompetence, reportedProblemsIds)

    if (commonCompetence === reportedProblemsNumbersLength)
        return (
            <div className={style.container}>
                <Img src="writing-hand-white-emoji.png" width={24} height={24} />
                <div>Работает со&nbsp;всеми вашими запросами</div>
            </div>
        )
    else if (commonCompetence !== reportedProblemsNumbersLength && commonCompetence > 0)
        return (
            <div className={style.container}>
                <Img src="writing-hand-white-emoji.png" width={24} height={24} />
                <div>
                    Работает&nbsp;с {commonCompetence} из&nbsp;{reportedProblemsNumbersLength} ваших
                    запросов
                </div>
            </div>
        )

    return <></>
}
